import React from 'react'
import { SectionHeader } from '../../../../component'
import { useTranslation } from '../../../../utils/convergence'
import { OrderBreakdown } from '../../../../component/OrderBreakdown/OrderBreakdown'

export const Summary = (): JSX.Element => {
  const { t } = useTranslation()

  return (
    <>
      <SectionHeader title={t('summary:summary')} />
      <OrderBreakdown />
    </>
  )
}
